import {
  findDefaultHomePath,
  findMenuNodeByCode,
  getMenuChildren,
  type MenuNode,
} from '@/utils/menu';

export type CloudStudioActivation = { userId: string; activated: boolean };

export function isCloudStudioOnboardingPath(pathname: string) {
  const path = pathname.replace(/\/+$/, '');
  return path === '/cloud-studio/intro' || path === '/cloud-studio/activation';
}

export function getCloudStudioRedirect(
  pathname: string,
  activated: boolean,
  menuData: MenuNode[] = [],
) {
  const path = pathname.replace(/\/+$/, '');
  const isPublic =
    path === '/cloud-studio/marketplace' || isCloudStudioOnboardingPath(path);
  if (!activated && !isPublic) return '/cloud-studio/marketplace';
  if (
    activated &&
    (path === '/cloud-studio' || path === '/cloud-studio/intro')
  ) {
    const root = findMenuNodeByCode(menuData, 'CloudStudio');
    const children = root ? getMenuChildren(root) || [] : [];
    // 开通不授予菜单权限；只从后端已授权子菜单中选择入口。
    return findDefaultHomePath(children) || '/404';
  }
  return null;
}

export function isCloudStudioActivated(state?: {
  currentUser?: { userId?: string };
  cloudStudioActivation?: CloudStudioActivation;
}) {
  const userId = state?.currentUser?.userId;
  if (!userId) return false;
  return (
    state?.cloudStudioActivation?.userId === userId &&
    state.cloudStudioActivation.activated
  );
}

export function filterCloudStudioMenu(
  menuData: MenuNode[],
  activated: boolean,
): MenuNode[] {
  return menuData.map((item) => {
    if (item.code === 'CloudStudio') {
      return {
        ...item,
        name: '算力广场',
        path: '/cloud-studio',
        routes: activated ? item.routes : undefined,
        children: undefined,
      };
    }
    return item.routes
      ? { ...item, routes: filterCloudStudioMenu(item.routes, activated) }
      : item;
  });
}
